import { keyValueType } from "src/types/local-types";

export const SIGNAL_RESOLUTIONS: Array<keyValueType> = [
  {
    key: "RESOLUTION_15",
    value: "15m",
  },
  {
    key: "RESOLUTION_60",
    value: "1h",
  },
  {
    key: "RESOLUTION_240",
    value: "4h",
  },
  {
    key: "RESOLUTION_1D",
    value: "1d",
  },
];

export const SIGNAL_STRATEGY: Array<keyValueType> = [
  {
    key: "STRATEGY_TYPE_TREND_FOLLOWING",
    value: "trend",
  },
  {
    key: "STRATEGY_TYPE_MEAN_REVERSION",
    value: "reversal",
  },
];

export const SIGNAL_CONFIGS = {
  "2": {
    mcad: "MACD Slope Up",
    ema: "EMA 20 > EMA 100",
  },
  "1": {
    mcad: "MACD Slope Down",
    ema: "EMA 20 > EMA 100",
  },
  "0": {
    mcad: "",
    ema: "",
  },
  "-1": {
    mcad: "MACD Slope Up",
    ema: "EMA 20 < EMA 100",
  },
  "-2": {
    mcad: "MACD Slope Down",
    ema: "EMA 20 < EMA 100",
  },
  default: {
    mcad: "Not enough bars",
    ema: "",
  },
};
